export default __webpack_public_path__ + "static/media/glass.06b6bf1b.svg";